module.exports = __webpack_public_path__ + "static/media/not_set_shared.e97494f3.svg";